import { Dispatch, SetStateAction, createContext } from 'react';

export interface ComparisonContextType {
  open?: boolean;
  sticky?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>> | ((open: boolean) => void);
  setSticky?: Dispatch<SetStateAction<boolean>> | ((sticky: boolean) => void);
  heightGradiantTransition?: number;
  topGradiantTransition?: number;
  maxHeight?: number | 'auto';
  setMaxHeight?: Dispatch<SetStateAction<number | 'auto'>>;
}

export const ComparisonContext = createContext<ComparisonContextType>({});
